import { IGSPCommonElement } from './Interface/IGSPCommonElement';
import { ElementCodeRuleConfig } from './Element/ElementCodeRuleConfig';
import { ElementDefaultVauleType } from './Element/ElementDefaultVauleType';
import { GspCommonField, GSPElementDataType, GSPElementObjectType } from '../ref';
import { GSPAssociation } from './Element/GSPAssciation';

/**
 * 字段定义
 * @author wangjiegj<wangjiegj@inspur.com>
 */


/**
 * 字段定义
 */
export class GSPCommonElement extends GspCommonField implements IGSPCommonElement {

    constructor() {
        super();
        // this.ID = Guid.newGuid();
        this.Length = 36;
        this.Precision = 0;
        this.MDataType = GSPElementDataType.String;
        this.ObjectType = GSPElementObjectType.None;
        this.IsMultiLanguage = false;
        this.IsRequire = false;
        this.IsRef = false;
        this.IsPersistent = true;
        this.CustomizeRefObjectID = '';
        this.CustomizeRefElementID = '';
        this.IsEnableEncryption = false;
    }

    /**
     * 编码规则配置
     */
    public BillCodeConfig: ElementCodeRuleConfig;

    /**
     * 字段默认值类型
     */
    public DefaultVauleType: ElementDefaultVauleType;

    /**
     * 字段对象类型(默认None)
     */
    public ObjectType: GSPElementObjectType = GSPElementObjectType.None;

    /**
     * 对应的数据对象的列ID
     */
    public ColumnID: string;

    // /**
    //  * (0622删-g)虚拟字段的自定义表达式。只对虚拟字段才有效。
    //  */
    // public CustomExpression: string;

    /**
     * 是否只读
     */
    Readonly: boolean;

    /**
     * 是否自定义项
     */
    public IsCustomItem: boolean;

    /**
     * 当前属性所属结点
     */
    // public BelongObject: IGSPCommonObject;

    /**
     * 所属Asso
     */
    // public ParentAssociation: GSPAssociation;

    /**
     * 包含的关联列表
     */
    ChildAssociations: GSPAssociation[];

    /**
     * 字段是否参与持久化处理
     */
    public IsPersistent: boolean;

    /**
     * 运行时定制参考节点
     */
    public CustomizeRefObjectID: string;

    /**
     * 运行时定制参考字段
     */
    public CustomizeRefElementID: string;
    /**
     * 是否加密字段
     */
    public IsEnableEncryption: boolean;
}
